import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <main className="App">
      <Outlet />
      {/* represent all the children of layout component in app.js*/}
    </main>
  );
};

export default Layout;
